import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { AddSeriesBtn, CloseBtn } from 'components/lib/buttons/IconButtons';
import SeriesComparisonControlledSelect from 'components/lib/formElements/SeriesComparisonControlledSelect';
import styles from 'styles/components/lib/cards/comparedSeries.css';

const ComparedSeries = props => {
  return (
    <div style={{borderRight: (props.series3) ? 'none' : '1px solid #EEE'}} className={styles.container}>
      <div style={{backgroundColor: props.color, border: `1px solid ${props.color}`}} className={styles.circle}></div>
      <div className={styles.content}>
        <p className={styles.title}>{props.seriesName}</p>
        <div className={styles.subInfoContainer}>
          <div className={styles.subInfo}>
            <p className={styles.label}>Total Revenue</p>
            <p className={styles.num}>{props.total}</p>
          </div>
          <div className={styles.subInfo}>
            <p className={styles.label}>Avg. Ticket Price</p>
            <p className={styles.num}>{props.avgPrice}</p>
          </div>
        </div>
      </div>
      { props.hasClearButton &&
        <CloseBtn onClick={() => {props.onClear(props.seriesType)}} style={{position: 'absolute', right: '0'}}/>
      }
    </div>
  )
}
export default ComparedSeries;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/cards/ComparedSeries.js